import type { ApiSettingsResponse } from "../../models/api/admin/apiSettings";
import { useS2DApiSWR } from "../common/s2dApiSWR";

export const useGetApiSettings = (skipFetch?: boolean) => {
    const path = skipFetch ? null : `api/settings`;
    const { data, error, isLoading, refetch } =
        useS2DApiSWR<ApiSettingsResponse>(path, {
            preventRedirectOn404: true,
        });

    return {
        apiSettings: data,
        isApiSettingsLoading: isLoading,
        apiSettingsError: error,
        refetchApiSettings: refetch,
    };
};
